<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToSignup = () => {
  router.push({ name: 'signup' })
}
</script>

<template>
  <v-btn
    @click="goToSignup"
    variant="outlined"
    aria-label="Sign up redirect"
    class="header-toolbar__auth-btn v-btn__dark"
    >Sign up</v-btn
  >
</template>

<style scoped>
.header-toolbar__auth-btn {
  height: 60px !important;
  font-size: 18px;
  font-style: normal;
  line-height: 22px; /* 122.222% */
}

@media (max-width: 1024px) {
  .header-toolbar__auth-btn {
    height: 40px !important;
  }
}
</style>
